import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { IndividualChecklistService } from './individual-checklist.service';
import ConsentChecklistTask from '../../../interfaces/consent-checklist-task';
import ID from '../../../types/id';
import { DialogRef } from '@angular/cdk/dialog';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import Participant from "../../../interfaces/participant";

type ChecklistDialogData = {
  consentRequestId: ID;
};
@Component({
    selector: 'app-individual-checklist-dialog',
    templateUrl: './individual-checklist-dialog.component.html',
    styleUrls: ['./individual-checklist-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IndividualChecklistDialogComponent {
  constructor(
    public dialog: MatDialog,
    public checklistService: IndividualChecklistService,
    public dialogRef: DialogRef<IndividualChecklistDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChecklistDialogData
  ) {}

  openCreateDialog() {
    let dialog = this.dialog.open(EditDialogComponent, {
      width: '40vw',
      data: {
        isExisting: false,
        consent_request_id: this.data.consentRequestId,
      },
    });
  }

  ngOnInit() {
    this.checklistService.getConsentChecklist(this.data.consentRequestId);
  }

  public retrieveSponsor(){
    let sponsor = null;
    this.checklistService.consentRequest$.subscribe((data) => {
      sponsor = data?.project?.participants?.find((prc: Participant) => prc.role.name == 'Sponsor')?.sponsor ?? null
    })
    return sponsor
  }
}
